import { render, staticRenderFns } from "./batchTypingDialog.vue?vue&type=template&id=2c1853aa&scoped=true&"
import script from "./batchTypingDialog.vue?vue&type=script&lang=js&"
export * from "./batchTypingDialog.vue?vue&type=script&lang=js&"
import style0 from "./batchTypingDialog.vue?vue&type=style&index=0&id=2c1853aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1853aa",
  null
  
)

export default component.exports